import * as React from "react";
import { useState } from "react";
import DeleteMeetingDialog from "./DeleteMeetingDialog";
import { DeleteIcon } from "./icons";
import { IconButton } from "@mui/material";

type Props = {
    meetingId: number;
    name: string;
    onSuccess: () => void;
};

export default ({ meetingId, onSuccess, name }: Props) => {
    const [open, setOpen] = useState(false);
    return (
        <React.Fragment>
            <IconButton color="secondary" onClick={() => setOpen(true)} size="small">
                <DeleteIcon fixedWidth />
            </IconButton>
            <DeleteMeetingDialog
                name={name}
                meetingId={meetingId}
                isOpen={open}
                close={() => setOpen(false)}
                onSuccess={onSuccess}
            />
        </React.Fragment>
    );
};
